<template>
  <base-modal
    title="MOVE TO FOLDER"
    :id="id"
    :value="value"
    extra-class="modal-sm"
    @shown="clear"
    @input="$emit('input', $event)"
  >
    <form data-vv-scope="move-to-folder">
      <div class="form-group">
        <vue-select
          v-model="targetFolder"
          :options="accountFolders"
          label="name"
          value="id"
          :multiple=false
          placeholder="Select folder"
        >
          <template slot="option" slot-scope="option">
            <template v-if="option.lvl > 1" v-for="idx in option.lvl">&nbsp;&nbsp;</template>
            {{ option.name }}
          </template>
        </vue-select>
      </div>
    </form>
    <template #footer>
      <button class="btn green mt-ladda-btn ladda-button remove-participant-control" data-style="expand-left"
              @click.prevent="moveToFolder()">
        <span class="ladda-label">OK</span>
      </button>
      <button class="btn default" data-dismiss="modal">Cancel</button>
    </template>
  </base-modal>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import VueSelect from 'vue-select';

import BaseModal from "../BaseModal";

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    elementId: {
      required: true,
    },
    elementType: {
      required: true,
    }
  },
  data () {
    return {
      id: 'move-to-folder-modal',
      targetFolder: null,
    }
  },
  computed: {
    ...mapGetters({
      accountFolders: 'getAccountFolders',
    }),
  },
  methods: {
    ...mapActions({
      moveToFolderAction: 'MOVE_TO_FOLDER_ACTION',
      getAccountFoldersAction: 'GET_ACCOUNT_FOLDERS_ACTION',
    }),
    clear() {
      this.getAccountFoldersAction();
      this.addFolderName = '';
      this.$validator.reset();
    },
    moveToFolder() {
      this.$validator.validateAll('move-to-folder').then((result) => {
        if (result) {
          this.moveToFolderAction({'itemType' : this.elementType, 'itemId' : this.elementId, 'folderId' : this.targetFolder.id});
          $(`#${this.id}`).modal('hide');
        }
      });
    }
  },
  components: {
    BaseModal,
    VueSelect,
  },
  emits: ['save', 'input'],
}
</script>



// WEBPACK FOOTER //
// MoveToFolderModal.vue?1a567359